import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { getJobs_id2, getCompany2 } from "../../../services/userservice";
import { API_URL } from "../../../config";
import companyImg from "../../../assets/images/companyImg.jpg";

const JobDetailsDescription = ({ jobId }) => { 
  const [jobs, setJobs] = useState(null); 
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [salary, setSalary] = useState("");
  const [modality, setModality] = useState("");
  const [img, setImg] = useState("");
  const [compania, setCompania] = useState("");
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    if (!jobId) return;

    setLoading(true);
    getJobs_id2(jobId)
      .then((data) => {
        setJobs(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, [jobId]);

  useEffect(() => {
    if (jobs) {
      setTitle(jobs.title);
      setDescription(jobs.description);
      setSalary(jobs.salary);
      setModality(jobs.modality);
      setCompania(jobs.company_id);
    }
  }, [jobs]);

  useEffect(() => {
    if (!compania) return;

    getCompany2(compania)
      .then((companyData) => {
        setImg(companyData.photo);
      })
      .catch((error) => console.error(error));
  }, [compania]);

  if (loading) return <div>Cargando...</div>;
  if (!jobs) return <div>No se encontró la oferta de trabajo</div>;

  return (
    <React.Fragment>
      <Card className="job-detail overflow-hidden pt-5">
        <div>
          <div className="job-details-compnay-profile">
            <img
              src={img ? `${API_URL}/download2/${img}` : companyImg}
              alt=""
              className="img-fluid rounded-3"
              style={{ width: "75px", height: "75px", objectFit: "cover", marginTop: "2%" }}
              onError={(e) => { e.target.src = companyImg; }}
            />
          </div>
        </div>
        <CardBody className="p-4">
          <div>
            <Row>
              <Col md={8}>
                <h5 className="mb-1">{title}</h5>
              </Col>
            </Row>
          </div>

          <div className="mt-4">
            <Row className="g-2">
              <Col lg={6}>
                <div className="border p-3">
                  <p className="text-muted fs-13 mb-0">Tipo de Empleo</p>
                  <p className="fw-medium mb-0">{modality}</p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="border rounded-end p-3">
                  <p className="text-muted fs-13 mb-0">Oferta Salarial</p>
                  <p className="fw-medium mb-0">{salary}/ Mes</p>
                </div>
              </Col>
            </Row>
          </div>

          <div className="mt-4">
            <h5 className="mb-3">Descripcion</h5>
            <div className="job-detail-desc">
              <p className="text-muted mb-0">{description}</p>
            </div>
          </div>

          <div className="mt-4">
            <h5 className="mb-3">Modalidad</h5>
            <div className="job-detail-desc mt-2">
              <span>
                <strong>{modality}</strong>
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default JobDetailsDescription;